import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { LoadNoteType } from '../../shared/load-note-type.model';
import { LocalNoteService } from '../../shared/local-note.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { Carrier } from '../../../user-dashboard/shared/carrier.model';
import { Observable } from 'rxjs';
import { LocalNote } from '../../shared/local-note.model';
import { LocalLoadCommunication } from '../../shared/local-load-communication.model';
import { LocalLoadService } from '../../shared/local-load.service';
import { finalize } from 'rxjs/operators';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';

@Component({
  selector: 'app-load-communication',
  templateUrl: './load-communication.component.html',
  styleUrls: ['./load-communication.component.scss']
})
export class LoadCommunicationComponent implements OnInit, OnChanges {

  @Input()
  loadUuid: string;

  @Input()
  communication: LocalLoadCommunication;

  @Input()
  carrier: Carrier;

  @Input()
  noteTypes: LoadNoteType[] = [];

  @ViewChild('notesElement')
  notesElement: ElementRef;

  selectedNoteType: LoadNoteType;

  addNoteSubject = 'CMA Web discussion';

  addNoteMessage;

  expanded = true;

  currentUserEmail;

  inputHasFocus = false;

  activeTab = 'notes';

  constructor(
    private authService: AuthenticationService,
    private localLoadService: LocalLoadService,
    private localNoteService: LocalNoteService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {
    this.currentUserEmail = authService.getUserProfile().email;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.noteTypes && changes.noteTypes.currentValue && changes.noteTypes.currentValue.length > 0) {
      this.selectedNoteType = changes.noteTypes.currentValue[0];
    }

    if (changes.communication && changes.communication.currentValue) {
      this.scrollNotesToBottom(false);
    }

    if (changes.loadUuid && changes.loadUuid.currentValue) {
      this.resetForm();
    }
  }

  resetForm() {
    this.addNoteMessage = null;
  }

  expand() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.scrollNotesToBottom(false);
    }
  }

  selectNoteType(noteType: LoadNoteType) {
    this.selectedNoteType = noteType;
  }

  onInputFocus() {
    this.inputHasFocus = true;
  }

  onInputBlur() {
    this.inputHasFocus = false;
  }

  addNote() {
    let addNoteObservable: Observable<LocalNote>;

    if (this.authService.canManageCarriers()) {
      addNoteObservable = this.localNoteService.addNoteForCarrier(
        this.carrier,
        this.loadUuid,
        this.addNoteSubject,
        this.addNoteMessage,
        this.selectedNoteType,
        this.currentUserEmail
      );
    } else {
      addNoteObservable = this.localNoteService.addNoteForSelfCarrier(
        this.loadUuid,
        this.addNoteSubject,
        this.addNoteMessage,
        this.selectedNoteType,
        this.currentUserEmail
      );
    }

    this.loader.startLoad();

    addNoteObservable
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(note => {
        this.communication.notes.push(note);

        this.resetForm();
        this.scrollNotesToBottom();
      }, e => this.errorHandler.handleHttpError(e, 'local-loads.search.details.errors.add-note', false));
  }

  scrollNotesToBottom(smooth = true) {
    if (this.expanded && this.activeTab === 'notes' && this.notesElement) {
      const nativeElement: HTMLDivElement = this.notesElement.nativeElement;

      const behavior: ScrollBehavior = smooth ? 'smooth' : 'auto';

      setTimeout(() => {
        nativeElement.scrollTo({ top: nativeElement.scrollHeight, behavior });
      }, 50);
    }
  }

  showPicture(note: LocalNote) {
    note.pictureUrl = `${this.localLoadService.getPictureRootUrl(note.id)}/inline`;
    note.showPicture();
  }

  downloadPicture(note: LocalNote) {
    this.loader.startLoad();

    this.localLoadService.downloadPicture(note.id)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe();
  }

}
